var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2455 7.75H7.25M4.75 7.75H4.75449",
    stroke: "#585B5F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1339 9.42235C2.24634 10.2575 2.93806 10.9117 3.77983 10.9504C4.48813 10.983 5.20765 11 6 11C6.79235 11 7.51185 10.983 8.22015 10.9504C9.06195 10.9117 9.75365 10.2575 9.8661 9.42235C9.9395 8.87735 10 8.3188 10 7.75C10 7.1812 9.9395 6.62265 9.8661 6.07765C9.75365 5.2425 9.06195 4.58824 8.22015 4.54954C7.51185 4.51698 6.79235 4.5 6 4.5C5.20765 4.5 4.48813 4.51698 3.77983 4.54954C2.93806 4.58824 2.24634 5.2425 2.1339 6.07765C2.06052 6.62265 2 7.1812 2 7.75C2 8.3188 2.06052 8.87735 2.1339 9.42235Z",
    stroke: "#585B5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.5V3.25C3.75 2.00736 4.75736 1 6 1C7.24265 1 8.25 2.00736 8.25 3.25V4.5",
    stroke: "#585B5F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassLock);
export default __webpack_public_path__ + "static/media/passLock.225debc59ee76bee7b2c100b7113fbec.svg";
export { ForwardRef as ReactComponent };